import React, {Fragment} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import constants from '../../helpers/constants';
import message from 'framework/modules/message';
import PropertyDetails from '../property-details/property-details';
import StarRating from '../review-ratings/star-rating';
import SuperlativeRating from '../review-ratings/superlative-rating';
import './listing-info.less';
import egtnlUtil from '../../helpers/egtnl-util';
import CarouselPreviewContainer from '../listing-info/image-carousel/carousel-preview-container';
import GuestChoice from '../guest-choice/guest-choice-badge';
import url from '../../helpers/url';

const ListingInfo = ({listing, media}) => {
    const isSeparateMediaCallEnabled = egtnlUtil.isSeparateMediaCallEnabled();
    const guestChoice = url.getUrlParameter('guestChoice');
    const headline = listing?.headline || '';

    if (isSeparateMediaCallEnabled) {
        const getListingComponent = () => {
            const {
                averageRating,
                reviewCount,
                reviewScoreSplitBadges,
                address,
            } = listing;
            const showSuperlativeRating =
                _.isNumber(averageRating) &&
                _.round(averageRating, 1) >= constants.MIN_SUPERLATIVE_RATING &&
                reviewCount >= 5;

            return (
                <>
                    <div className="listing-property-info">
                        <PropertyDetails
                            headline={headline}
                            address={address}
                            rating={
                                !showSuperlativeRating && reviewCount > 0 ? (
                                    <StarRating
                                        averageRating={averageRating}
                                        reviewCount={reviewCount}
                                    />
                                ) : null
                            }
                        />
                        {guestChoice && <GuestChoice variant={guestChoice} />}
                        {showSuperlativeRating && (
                            <SuperlativeRating
                                averageRating={averageRating}
                                reviewCount={reviewCount}
                                reviewScoreSplitBadges={reviewScoreSplitBadges}
                            />
                        )}
                    </div>
                </>
            );
        };

        return (
            <>
                <span
                    className="sr-only"
                    tabIndex="-1"
                    id="skipToPropertyInformation"
                >
                    {message.read(
                        'traveler.checkout.skip_menu.property_information_anchour'
                    )}
                </span>

                {media && (
                    <CarouselPreviewContainer
                        images={media.images}
                        thumbnailUrl={media.thumbnailUrl}
                        headline={headline}
                    />
                )}
                {listing && getListingComponent()}
            </>
        );
    }

    // Legacy implementation
    if (!listing) {
        return null;
    }

    const {
        averageRating,
        reviewCount,
        reviewScoreSplitBadges,
        images,
        thumbnailUrl,
        address,
    } = listing;
    const showSuperlativeRating =
        _.isNumber(averageRating) &&
        _.round(averageRating, 1) >= constants.MIN_SUPERLATIVE_RATING &&
        reviewCount >= 5;

    return (
        <Fragment>
            <span
                className="sr-only"
                tabIndex="-1"
                id="skipToPropertyInformation"
            >
                {message.read(
                    'traveler.checkout.skip_menu.property_information_anchour'
                )}
            </span>
            <CarouselPreviewContainer
                images={images}
                thumbnailUrl={thumbnailUrl}
                headline={headline}
            />

            <div className="listing-property-info">
                <PropertyDetails
                    headline={headline}
                    address={address}
                    rating={
                        !showSuperlativeRating && reviewCount > 0 ? (
                            <StarRating
                                averageRating={averageRating}
                                reviewCount={reviewCount}
                            />
                        ) : null
                    }
                />
                {guestChoice && <GuestChoice variant={guestChoice} />}
                {showSuperlativeRating && (
                    <SuperlativeRating
                        averageRating={averageRating}
                        reviewCount={reviewCount}
                        reviewScoreSplitBadges={reviewScoreSplitBadges}
                    />
                )}
            </div>
        </Fragment>
    );
};

ListingInfo.propTypes = {
    listing: PropTypes.shape({}),
    media: PropTypes.shape({
        images: PropTypes.arrayOf(PropTypes.shape({})),
        thumbnailUrl: PropTypes.string,
    }),
};

ListingInfo.defaultProps = {
    listing: null,
    media: null,
};

export default ListingInfo;
